export default "__VITE_ASSET__BXbFL5AP__"